import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup } from "components";
import {
	minLength4,
	onlyMaxDigits4,
	required,
	trimNormalizer,
} from "validators";

import styles from "../terminalSolution.module.scss";

type TsysSummitProps = {
	isLoading: boolean;
	sectionName?: string;
};

const TsysSummit = ({ isLoading, sectionName }: TsysSummitProps) => {
	const { register } = useFormContext();

	return (
		<div className={styles.section} data-autotest="tsysSummitSection">
			<Row className="form-group">
				<Col md={5}>
					<HookFormInputGroup
						name={`${sectionName}.terminalNumber`}
						register={register}
						label="Terminal #"
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						autoComplete="off"
						showRequiredMark
						validator={{
							minLength4,
							required,
						}}
						normalize={onlyMaxDigits4}
						normalizeOnBlur={trimNormalizer}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<HookFormInputGroup
						name={`${sectionName}.storeNumber`}
						register={register}
						label="Store Number"
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						autoComplete="off"
						showRequiredMark
						validator={{ minLength4, required }}
						normalize={onlyMaxDigits4}
						normalizeOnBlur={trimNormalizer}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default TsysSummit;
